// card3.regulations -> rows for RegulatedScatterChart + filters
export const getRegulatedStats = (overview) =>
  (overview?.card3?.regulations || []).map((r) => ({
    "FileClassificationStats.classificationCombination": r.label,
    "FileClassificationStats.fileCount": Number(r.count) || 0,
  }));

// card3.severity -> rows for the Sensitivity badge
export const getSensitivityRows = (overview) =>
  (overview?.card3?.severity || []).map((s) => ({
    "DataTagSensitivity.category": s.label,
    "DataTagSensitivity.count": Number(s.count) || 0,
  }));

// card4.classifications -> rows for the Category spider graph
export const getCategoryRows = (overview) =>
  (overview?.card4?.classifications || []).map((c) => ({
    "DataTagSensitivity.finalType": c.label,
    "DataTagSensitivity.count": Number(c.count) || 0,
  }));

// card2.totalFiles (the denominator for the severity percentages)
export const getTotalFiles = (overview) => Number(overview?.card2?.totalFiles) || 0;

// card5.accessBuckets
export const getAccessBuckets = (overview) => overview?.card5?.accessBuckets || [];